"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("preact/jsx-runtime");
var hooks_1 = require("preact/hooks");
var api_1 = require("../api");
var ProjectSubmit_1 = require("./ProjectSubmit");
var SelectField_1 = require("./SelectField");
var lib_1 = require("../lib");
var i18n_1 = require("@wordpress/i18n");
function GlobalGapDetails(props) {
    var _this = this;
    var tripTypeId = props.tripTypeId;
    var _a = (0, hooks_1.useState)([]), globalGapYears = _a[0], setGlobalGapYears = _a[1];
    var _b = (0, hooks_1.useState)(""), selectedGlobalGapId = _b[0], setSelectedGlobalGapId = _b[1];
    var _c = (0, hooks_1.useState)([]), globalGapProjects = _c[0], setGlobalGapProjects = _c[1];
    var _d = (0, hooks_1.useState)(false), isValid = _d[0], setIsValid = _d[1];
    var _e = (0, hooks_1.useState)(''), description = _e[0], setDescription = _e[1];
    var updateGlobalGapYears = function () { return __awaiter(_this, void 0, void 0, function () {
        var years;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, api_1.getGlobalGapYears)()];
                case 1:
                    years = _a.sent();
                    setGlobalGapYears(years);
                    if (years.length === 1) {
                        setSelectedGlobalGapId(years[0].id);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var updateGlobalGapProjects = function (globalGapId) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, api_1.getGlobalGapProjects)(globalGapId)];
                case 1:
                    result = _a.sent();
                    setGlobalGapProjects(result.destinations);
                    setDescription(result.description);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, hooks_1.useEffect)(function () {
        if (tripTypeId !== "") {
            updateGlobalGapYears();
        }
    }, [tripTypeId]);
    (0, hooks_1.useEffect)(function () {
        if (selectedGlobalGapId !== "") {
            updateGlobalGapProjects(selectedGlobalGapId);
            setIsValid(true);
        }
        else {
            setGlobalGapProjects([]);
            setIsValid(false);
        }
    }, [selectedGlobalGapId]);
    var ProjectDetails = function (_a) {
        var _b;
        var project = _a.project;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "appform-global-gap-project" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "appform-global-gap-project__title-wrapper" }, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ class: "appform-global-gap-project__title-label" }, { children: [(0, i18n_1.__)("Project", "projects-abroad"), ":"] })), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)("strong", { children: (_b = project.project) !== null && _b !== void 0 ? _b : (0, i18n_1.__)("Choice of projects", "projects-abroad") }) })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "appform-global-gap-project__dates" }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ className: "appform-global-gap-project__start" }, { children: (0, i18n_1.__)("Start", "projects-abroad") })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "appform-global-gap-project__start-date" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: (0, lib_1.formatDate)(project.startDate) }) })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "appform-global-gap-project__end" }, { children: (0, i18n_1.__)("Finish", "projects-abroad") })), (0, jsx_runtime_1.jsx)("span", __assign({ className: "appform-global-gap-project__end-date" }, { children: (0, jsx_runtime_1.jsx)("strong", { children: (0, lib_1.formatDate)(project.endDate) }) })), (0, jsx_runtime_1.jsx)("span", { className: "appform-global-gap-project__date-line" })] }))] })));
    };
    if (globalGapYears.length === 0) {
        return null;
    }
    var selectHidden = selectedGlobalGapId && (globalGapYears.length === 1);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "trip_type_id", value: tripTypeId }), selectHidden ?
                (0, jsx_runtime_1.jsx)("div", __assign({ className: "appform-global-gap-details" }, { children: (0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "global_gap_id", value: selectedGlobalGapId }) }))
                :
                    (0, jsx_runtime_1.jsx)("div", __assign({ className: "appform-global-gap-details" }, { children: (0, jsx_runtime_1.jsx)(SelectField_1.default, { name: "global_gap_id", label: (0, i18n_1.__)("You have selected the Global Gap Year programme, a long-term volunteer programme for students taking a gap year between school and university. This programme spans roughly one school year, according to the following agenda:", "projects-abroad"), options: globalGapYears, defaultOptionLabel: (0, i18n_1.__)("Please select", "projects-abroad"), required: true, value: selectedGlobalGapId, onChange: function (e) { return setSelectedGlobalGapId(e.target.value); } }) })), (globalGapProjects.length > 0) && ((0, jsx_runtime_1.jsxs)("div", __assign({ class: "appform-global-gap-projects-wrapper" }, { children: [(0, jsx_runtime_1.jsx)("div", { class: "appform-global-gap-projects-description", dangerouslySetInnerHTML: { __html: description } }), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "appform-global-gap-projects" }, { children: globalGapProjects.map(function (destination) { return ((0, jsx_runtime_1.jsxs)("li", { children: [(0, jsx_runtime_1.jsx)("p", __assign({ className: "appform-global-gap-destination" }, { children: destination.destination })), destination.projects.map(function (p) { return ((0, jsx_runtime_1.jsx)(ProjectDetails, { project: p })); })] }, destination.destinationId)); }) }))] }))), isValid && ((0, jsx_runtime_1.jsx)(ProjectSubmit_1.default, {}))] }));
}
exports.default = GlobalGapDetails;
